var _defs, _g, _rect, _path, _path2, _path3, _path4, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrownImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3707",
    "data-name": "Group 3707",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 99.581,
    height: 61.188,
    viewBox: "0 0 99.581 61.188",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: -0.476,
    x2: 0.5,
    y2: 0.707,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.013,
    stopColor: "#fed33c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#fec831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708,
    stopColor: "#fea50d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    y1: -0.265,
    x2: 0.5,
    y2: 1.136,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.5,
    y1: 0.064,
    x2: 0.5,
    y2: 1.142,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.5,
    y1: -0.051,
    x2: 0.5,
    y2: 0.914,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.5,
    y1: 0.002,
    x2: 0.5,
    y2: 1.08,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.5,
    y1: -0.049,
    x2: 0.5,
    y2: 0.942,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3705",
    "data-name": "Group 3705",
    transform: "translate(17.696 14.396)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33713",
    "data-name": "Path 33713",
    d: "M228.8,112.92l22.532,24v16.8l-32.095-9.807Z",
    transform: "translate(-219.239 -112.92)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33714",
    "data-name": "Path 33714",
    d: "M253.05,112.92l-22.532,24v16.8l32.094-9.807Z",
    transform: "translate(-198.424 -112.92)",
    fill: "url(#linear-gradient)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_197",
    "data-name": "Rectangle 197",
    width: 56.39,
    height: 5.999,
    transform: "translate(21.596 55.189)",
    fill: "url(#linear-gradient-3)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_33715",
    "data-name": "Path 33715",
    d: "M275.627,139.874l-17.1-29.695-17.1,29.695-26.1-18,15,36.894h56.39l15-36.894Z",
    transform: "translate(-208.74 -103.581)",
    fill: "url(#linear-gradient-4)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_33716",
    "data-name": "Path 33716",
    d: "M241.4,114.458a6.6,6.6,0,1,0-6.6,6.6A6.6,6.6,0,0,0,241.4,114.458Z",
    transform: "translate(-185.008 -107.86)",
    fill: "url(#linear-gradient-5)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_33717",
    "data-name": "Path 33717",
    d: "M256.576,118.569a6.6,6.6,0,1,0-6.6,6.6A6.6,6.6,0,0,0,256.576,118.569Z",
    transform: "translate(-156.995 -100.274)",
    fill: "url(#linear-gradient-6)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_33718",
    "data-name": "Path 33718",
    d: "M226.215,118.569a6.6,6.6,0,1,0-6.6,6.6A6.6,6.6,0,0,0,226.215,118.569Z",
    transform: "translate(-213.019 -100.274)",
    fill: "url(#linear-gradient-7)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3706",
    "data-name": "Group 3706",
    transform: "translate(44.192 30.894)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33719",
    "data-name": "Path 33719",
    d: "M234.15,118.718l-5.6,8.931,5.6,8.931,5.6-8.931Z",
    transform: "translate(-228.551 -118.718)",
    fill: "#ff29e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33720",
    "data-name": "Path 33720",
    d: "M231.109,118.718l-.911,8.931.911,8.931,5.6-8.931Z",
    transform: "translate(-225.51 -118.718)",
    fill: "#b607a1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrownImg);
export default __webpack_public_path__ + "static/media/crown-img.f273f87bf3ba9a0a903298efe025a233.svg";
export { ForwardRef as ReactComponent };